<!-- 新闻列表 -->
<template>
  <transition name="el-fade-in-linear">
    <div id="newsList">
      <headerVue></headerVue>
      <div class="container">
        <!-- 左侧 -->
        <el-col :span="5" class="left-sider">
          <!-- h3 是左侧菜单大标题 -->
          <!-- 地方动态 -->
          <h3 v-if="this.$route.query.placeName">
            {{ this.$route.query.placeName }}
          </h3>
          <h3 v-else-if="this.$route.query.zwhName">
            {{ this.$route.query.zwhName }}
          </h3>
          <h3 v-else-if="this.$route.query.syfcName">
            {{ this.$route.query.syfcName }}
          </h3>
          <!-- 首页的导航栏 -->
          <h3 v-else-if="this.$route.query.name">{{ this.$route.query.name }}</h3>
          <h3 v-else-if="this.$route.query.title">
            {{ this.$route.query.title }}
          </h3>
          <!-- 全国人大代表那些 -->
          <h3 v-else-if="this.$route.query.stitle">
            {{ this.$route.query.stitle }}
          </h3>
          <!-- 6块小专栏 -->
          <h3 v-else>{{ this.$route.query.zlname }}</h3>
          <!-- default-active="0" 是默认激活的下标 -->
          <el-menu default-active="0" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
            <el-menu-item style="justify-content: center" v-for="(item, index) in navList"
              @click="toItemList(item.id, item.navName)" :index="index.toString()" :key="item.id">
              <span class="navTitle" slot="title">{{ item.navName }}</span>
            </el-menu-item>
          </el-menu>
        </el-col>
        <!-- 右侧 -->
        <el-col :span="19" class="right-sider">
          <div class="citylist">
            <!-- <div class="citybox" :style="{ width: 100 / navList.length + '%' }" -->
            <div class="citybox" style="width: 20%"
              :class="{ active: currentNav == item.navName }" v-for="(item, index) in navList"
              @click="toItemList(item.id, item.navName)" :index="index.toString()" :key="item.id">
              {{ item.navName }}
            </div>
          </div>

          <div class="right" v-if="newsList!=null && newsList.length !== 0 && this.$route.query.title !== '历届委员会'">
            <div class="content" v-for="item in newsList" :key="item.id">
              <img src="../../assets/image/picture/icon_local1.png" />
              <div class="title" @click="toDetails(item.id)">
                {{ item.title }}  
              </div>
              <span class="time hidden-sm-and-down">{{ item.releaseTime }}</span>
              <span class="time hidden-sm-up">{{
                item.releaseTime.substr(5, 11)
              }}</span>
            </div>
            <div class="load-more" style="text-align: center">
              <button v-if="total > 10 && query.pageSize * query.currentPage < total" @click="loadMore" class="btn-more">
                加载更多
              </button>
            </div>
          </div>

          <div class="right" v-else-if="this.$route.query.title === '历届委员会'">
            <div class="liji_content">
              <div class="" v-for="item in imgList" :key="item.id" style="
                width: 120px;
                height: 180px;
                margin: 0 6px 10px 0;
                text-align: center;
              ">
                <!-- {{ item }} -->
                <img @click="toDetailWei(item.id)" style="width: 120px; height: 150px"
                  :src="item.articleImg.startsWith('/profile') ? `http://www.shx93.gov.cn/prod-api${item.articleImg}` : `http://www.shx93.gov.cn/prod-api/profile/${item.articleImg}`"
                  alt="" srcset="" />
                {{ item.title }}
              </div>
            </div>
          </div>
          <div v-if="newsList!=null && newsList.length == 0">
            <p style="
              color: #ccc;
              text-align: center;
              line-height: 230px;
              font-size: 28px;
            ">
              暂无数据
            </p>
          </div>

          <!-- 分页 -->
          <el-pagination v-if="this.$route.query.title !== '历届委员会'" class="page"
            style="margin-top: 16px;float: right;margin-right: 10px;" background
            layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[10]" :page-size="query.pageSize"
            :current-page="query.currentPage" @size-change="changePageSize" @current-change="currentPage">
          </el-pagination>
        </el-col>
      </div>

      <footerVue></footerVue>
    </div>
  </transition>
</template>

<script>
import headerVue from "../index/header.vue";
import footerVue from "../foot/foot.vue";
import { isMobile } from "@/utils/common.js";
export default {
  name: "newsList",
  data() {
    return {
      currentNav: "",
      currentNavId: "",
      navList: [],
      newsList: null,
      total: 0,
      imgList: [],
      // 分页
      pageData: {
        // 一页几条
        pageSize: 10,
        // 当前页数
        currentPage: 1,
      },
      query: {
        // 当前页数
        currentPage: 1,
        // 一页几条
        pageSize: 10,
      },
      fontSize: "18px"
    };
  },
  created() {
    // 在首次进入和路由切换时右侧文章列表都需要默认展示第一个菜单下的文章
    if (this.$route.query.placeName === '地方动态') {
      this.currentNavId = '1149996492862259200'
    }
    if (this.$route.query.name) {
      this.currentNavId = this.$route.query.stm
    }
    if (!isMobile) {
      this.toItemList(this.$route.query.show);
    }
    this.getNavList();
    this.getNewsList();
    this.getWeiImgList();
    this.fontSizeChange()
  },
  methods: {
    // 只有专题专栏字号是15px，其他的是18px
    fontSizeChange() {
      if (this.$route.query.title === '专题专栏') {
        this.fontSize = "15px"
        // console.log('侧边栏字号15px');
      } else {
        this.fontSize = "18px"
        // console.log('侧边栏字号18px');
      }
    },
    toDetailWei(_id) {
      this.$router.push(`/newsDetail?tm=${_id}`);
    },
    // 点击菜单项
    async toItemList(_id, navName) {
      // console.log('1111111111111',navName);
      // console.log('aaaaaaaa',this.navList);
      this.currentNav = navName;
      this.currentNavId = _id;
      // console.log("_id和navName", _id, navName);
      // 每切换一次新的菜单项，都要重置当前页为第一页
      this.query.currentPage = 1
      // console.log('this.query.currentPage',this.query.currentPage); 

      if (_id === undefined && this.$route.query.placeName === "地方动态") {
        // console.log("地方动态");
        // this.query.pageSize = "14";
        let res = await this.$api.nav.getArticle(
          1149996492862259200,
          // _id,
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          this.$route.query.year
        );
        // console.log(res);
        this.newsList = res.data.rows;
        this.total = res.data.total;
        // console.log("this.newsList", this.newsList);
      } else if (this.$route.query.placeName === "大事记") {
        let res = await this.$api.nav.getArticle(
          "",
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          navName,
          "大事记"
        );
        // console.log('大事记列表', res);
        this.newsList = res.data.rows;
        this.total = res.data.total;
        // console.log("this.newsList", this.newsList);
      } else if (this.$route.query.title === "历届委员会") {
        let res = await this.$api.nav.getWeiImgLists(
          // this.query.currentPage,
          // this.query.pageSize,
          _id
        );
        this.imgList = res.data.rows;
        // console.log("img", this.newsList);
      } else if (this.$route.query.zwhName === "专委会及工作机构") {
        let res = await this.$api.nav.getArticle(
          this.$route.query.tm,
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          this.$route.query.year,
          '专委会及工作机构'
        );
        this.newsList = res.data.rows;
        this.total = res.data.total;
      } else if (this.$route.query.title === "历史回眸") {
        let res = await this.$api.nav.getArticle(
          this.$route.query.tm,
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          this.$route.query.year,
          '历史回眸'
        );
        this.newsList = res.data.rows;
        // console.log('历史回眸的文章列表', this.newsList);
        this.total = res.data.total;
      } else if (this.$route.query.syfcName === "社员风采") {
        let res = await this.$api.nav.getArticle(
          this.$route.query.tm,
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          this.$route.query.year,
          '社员风采'
        );
        this.newsList = res.data.rows;
        this.total = res.data.total;
      } else if (this.$route.query.title === "专题专栏") {
        let res = await this.$api.nav.specialGetArticle(
          this.query.currentPage,
          this.query.pageSize,
          1,
          navName,
        );
        // console.log(res);
        this.newsList = res.data.rows;
        this.total = res.data.total;
        // console.log("this.newsList", this.newsList);
      }
      else {
        let res = await this.$api.nav.getArticle(
          _id,
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          this.$route.query.year
        );
        // console.log('切换222222222222222222222', res.data.rows);
        this.newsList = res.data.rows;
        this.total = res.data.total;
      }
    },
    // 新闻列表跳转至新闻详情
    toDetails(_id) {
      this.$router.push(`/newsDetail?tm=${_id}`);
    },
    // 菜单栏的相关函数
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    // 获取侧边的菜单栏列表
    async getNavList() {
      if (this.$route.query.name) {
        let res = await this.$api.nav.getNavList(1, this.$route.query.tm);
        this.navList = res.data.data;
        this.currentNav = this.navList[0].navName;
        if (!this.$route.query.stm) {
          this.$route.query.stm = this.navList[0].id;
        }
      } else if (this.$route.query.placeName === "地方动态") {
        let res = await this.$api.nav.getshenei("地方组织动态");
        this.navList = res.data.data;
        // console.log('地方动态侧边栏', res.data);
        this.navList.map(item => {
          if (item.navName === '西安市') {
            item.navName = '九三学社西安市委员会'
          } else if (item.navName === '咸阳市') {
            item.navName = '九三学社咸阳市委员会'
          } else if (item.navName === '宝鸡市') {
            item.navName = '九三学社宝鸡市委员会'
          } else if (item.navName === '渭南市') {
            item.navName = '九三学社渭南市委员会'
          } else if (item.navName === '汉中市') {
            item.navName = '九三学社汉中市委员会'
          } else if (item.navName === '榆林市') {
            item.navName = '九三学社榆林市委员会'
          } else if (item.navName === '杨凌区') {
            item.navName = '九三学社杨凌区工委'
          }
        })
        this.currentNav = this.navList[0].navName;
        // console.log(this.navList);
      } else if (this.$route.query.placeName === "大事记") {
        let res = await this.$api.nav.getYear();
        this.navList = res.data.rows;
        let arr = [];
        this.navList.map((item) => {
          arr.push({ navName: item });
        });
        this.navList = arr;
        // console.log('大事记侧边栏列表', this.navList);
      } else if (this.$route.query.title === "历届委员会") {
        let res = await this.$api.nav.getNavList(3, 0);
        // console.log("历届委员会", res.data.data[0].id);
        // res.data.data.map(item=>console.log(item))
        let res1 = await this.$api.nav.getNavList(3, res.data.data[0].id);
        this.navList = res1.data.data;
        // console.log("历届委员会4444", res1);
      } else if (this.$route.query.zwhName === "专委会及工作机构") {
        this.navList = [{ navName: '专委会及工作机构' }];
        this.currentNav = this.navList[0].navName;
      } else if (this.$route.query.title === "历史回眸") {
        this.navList = [{ navName: '历史回眸' }];
        this.currentNav = this.navList[0].navName;
      } else if (this.$route.query.syfcName === '社员风采') {
        this.navList = [{ navName: '社员风采' }];
        this.currentNav = this.navList[0].navName;
      } else if (this.$route.query.title === '历史回眸') {
        this.navList = [{ navName: '历史回眸' }];
        this.currentNav = this.navList[0].navName;
      } else if (this.$route.query.stitle) {
        // 全国人大代表等
        // 用一级菜单的 id 获取它对应的二级菜单
        this.navList = []
        let res = await this.$api.nav.getNavList(1, this.$route.query.tm);
        // console.log('啊啊啊啊啊啊啊啊啊啊啊啊', res.data.data);
        res.data.data.forEach(element => {
          this.navList.push({ navName: element.navName, id: element.id })
        });
        this.currentNav = this.navList[0].navName;
        // console.log('navlist---------------------',this.navList);
      }
      else if (this.$route.query.title === '专题专栏') {
        // this.navList = [{ navName: '专题专栏' }];
        let res = await this.$api.nav.getNavList(3, '1151096106717806592');
        this.navList = res.data.data;
        this.currentNav = this.navList[0].navName;
        // console.log('专题专栏侧边栏', res.data.data);
      }
      else {
        let res = await this.$api.nav.getNavList(2, this.$route.query.tm);
        this.navList = res.data.data;
      }
      // if(isMobile){
      //   this.currentNav = this.navList[0].navName;
      //   this.$router.push(`/newsList?tm=${_id}&name=${currentNav}&stm=${his.navList[0].id}`);
      //   // this.getNewsList();
      // }
    },
    // 获取右侧新闻列表
    async getNewsList() {
      if (this.$route.query.placeName == '大事记') {
        // 获取左侧列表，取第一个（给一进来显示第一个新闻列表的功能用）
        let res1 = await this.$api.nav.getYear();
        this.navList = res1.data.rows;
        let arr = [];
        this.navList.map((item) => {
          arr.push({ navName: item });
        });
        this.navList = arr;

        let res = await this.$api.nav.getArticle(
          "",
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          this.navList[0].navName,
          "大事记"
        );
        // console.log('大事记列表', res);
        this.newsList = res.data.rows;
        this.total = res.data.total;
      } else if (this.$route.query.zwhName === "专委会及工作机构") {
        let res = await this.$api.nav.getArticle(
          this.$route.query.tm,
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          this.$route.query.year,
          '专委会及工作机构'
        );
        this.newsList = res.data.rows;
        this.total = res.data.total;
      }
      else if (this.$route.query.syfcName === '社员风采') {
        let res = await this.$api.nav.getArticle(
          this.$route.query.tm,
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          this.$route.query.year,
          '社员风采'
        );
        this.newsList = res.data.rows;
        this.total = res.data.total;
      } else if (this.$route.query.placeName === "地方动态") {
        // console.log("地方动态");
        // this.query.pageSize = "14";
        let res = await this.$api.nav.getArticle(
          this.currentNavId,
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          this.$route.query.year
        );
        // console.log(res);
        this.newsList = res.data.rows;
        this.total = res.data.total;
        // console.log("this.newsList", this.newsList);
      } else if (this.$route.query.title === '专题专栏') {
        let res1 = await this.$api.nav.getNavList(3, '1151096106717806592');
        this.navList = res1.data.data;
        // console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~', this.navList);

        let res = await this.$api.nav.getArticle(
          this.$route.query.tm,
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          this.$route.query.year,
          this.navList[0].navName
        );
        this.newsList = res.data.rows;
        this.total = res.data.total;
      } else if (this.$route.query.title === '社内监督') {
        let res = await this.$api.nav.getArticle(
          this.$route.query.tm,
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          this.$route.query.year,
          '社内监督'
        );
        this.newsList = res.data.rows;
        this.total = res.data.total;
      } else if (this.$route.query.title === '历史回眸') {
        let res = await this.$api.nav.getArticle(
          this.$route.query.tm,
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          this.$route.query.year,
          '历史回眸'
        );
        this.newsList = res.data.rows;
        this.total = res.data.total;
      } else if (this.$route.query.stitle) {
        // 一进来默认显示列表里第一个的文章列表
        // 先获取一下左侧列表数据
        let res1 = await this.$api.nav.getNavList(1, this.$route.query.tm);
        let navList1 = []
        res1.data.data.forEach(element => {
          navList1.push({ navName: element.navName, id: element.id })
        });
        let res = await this.$api.nav.getArticle(
          this.$route.query.tm,
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          this.$route.query.year,
          // 只显示第一个
          navList1[0].navName
        );
        this.newsList = res.data.rows;
        this.total = res.data.total;
      }
      else {
        let res = await this.$api.nav.getArticle(
          // 首次进入用
          // this.$route.query.stm,
          // 切换过左侧菜单栏之后用
          this.currentNavId,
          this.query.currentPage,
          this.query.pageSize,
          1,
          this.$route.query.keyVal,
          this.$route.query.year
        );
        // console.log("22222222222222222222", res.data.rows);
        this.newsList = res.data.rows;
        this.total = res.data.total;
      }
    },
    // 获取历届委员会
    async getWeiImgList() {
      let res = await this.$api.nav.getWeiImgLists(
        "1156628875367677952"
        // this.query.currentPage,
        // this.query.pageSize,
      );
      // this.total = res.data.rows.total;
      this.imgList = res.data.rows;
      // console.log("img", res.data.rows);
    },
    async loadMore() {
      // 重新更新页面
      this.query.currentPage++;
      let res = await this.$api.nav.getArticle(
        this.currentNavId,
        this.query.currentPage,
        this.query.pageSize,
        1
      );
      this.newsList = this.newsList.concat(res.data.rows);
      // console.log('loadMore', this.newsList);
    },
    changePageSize(args) {
      // console.log(args);
      this.pageData.pageSize = args;
      this.query.pageSize = args;
      // 重新更新页面
      this.getNewsList();
      // this.toItemList();
      this.getWeiImgList();

      this.getNavList()
    },
    currentPage(args) {
      // console.log(args);
      this.pageData.currentPage = args;
      this.query.currentPage = args;
      // 重新更新页面
      this.getNewsList();
      // this.toItemList();
      this.getWeiImgList();

      this.getNavList()
    },
  },
  watch: {
    $route() {
      // console.log('this.$route.query.name', this.$route.query.name, this.currentNavId);

      if (this.$route.query.placeName === '地方动态') {
        this.currentNavId = '1149996492862259200'
      }
      if (this.$route.query.name) {
        this.currentNavId = this.$route.query.stm
      }

      this.getNavList();
      this.getNewsList();
      // this.toItemList();
      this.getWeiImgList();
      this.fontSizeChange()
      // 每次路由换了，也要重置当前页码
      this.query.currentPage = 1
    },
  },
  components: {
    headerVue,
    footerVue,
  },
};
</script>

<style lang="scss" scoped>
#newsList {
  background-color: #f5f5f5;
}

/*
 滚动条样式
*/
::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
}

.container {
  background-color: white;
  margin-top: 0px;
  // height: 650px;/
  max-width: 1200px;

  .el-menu-vertical-demo {
    max-height: 560px;
    overflow-y: scroll;
  }

  .el-col-5 {
    width: 20.83333%;
    // margin-left: -16px;
    border: 1px solid #1c74cd;
  }

  .el-col-5 h3 {
    background-color: #1c74cd;
    color: white;
    padding: 20px;
    text-align: center;
    font-weight: lighter;
    font-size: 22px;
  }

  .el-menu-item {
    font-size: 15px;
    height: 80px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
  }

  .el-menu-item:hover {
    background-color: #ecf5ff;
    color: #409eff;
    // font-weight: 600;
  }

  .right {
    width: 100%;
    // height: 570px;
    // border: 1px solid #f5f5f5;
    overflow-y: scroll;

    .content {
      display: flex;
      align-items: center;
      padding: 17px;
      border-bottom: 1px solid #f0f0f0;
      position: relative;
      background-color: white;

      img {
        margin-right: 10px;
      }

      .title {
        width: 720px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      span {
        position: absolute;
        right: 0px;
        padding-right: 20px;
        font-size: 14px;
        color: #999999;
      }
    }

    .liji_content {
      width: 100%;
      // background-color: #e49d9d;
      display: flex;
      flex-wrap: wrap;
    }
  }
}

.content:hover .title {
  color: #3181d1;
  transition: all 0.5s linear;
  cursor: pointer;
}

.el-pagination .el-select .el-input .el-input__inner {
  padding-right: 10px;
}

.el-input__suffix {
  display: none;
}

// .page {
//   display: fixed;
//   position: absolute;
//   bottom: -360px;
//   right: 260px;
// }
.citylist {
  display: none;
}

.load-more {
  display: none;
}

@media screen and (max-width: 768px) {
  .citylist {
    display: block;
    flex-wrap: wrap;
    display: flex;
    padding: 10px 10px 0 10px;

    .citybox {
      border: 1px solid #0b7dda;
      box-sizing: border-box;
      text-align: center;
      line-height: 30px;
      font-size: 14px;

      &:nth-child(n + 2) {
        border-left: 0px solid #0b7dda;
      }

      &:nth-child(6) {
        border-left: 1px solid #0b7dda;
      }

      &.active {
        background: #0b7dda;
        color: white;
      }
    }
  }

  .container {
    min-height: 0;
  }

  .left-sider,
  .page {
    display: none;
  }

  .load-more {
    display: block;
  }

  .btn-more {
    background: #0b7dda;
    padding: 10px 30px;

    border: none;
    color: white;
  }

  .right-sider {
    width: 100%;

    .right {
      margin-left: 0;
      height: auto;
    }
  }

  .container .right .content .title {
    width: auto;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    flex: 1 !important;
  }

  .time {
    position: relative !important;
    margin-left: 10px;
    display: inline-block;
    padding-right: 0 !important;
  }
}

// ::v-deep .container span[data-v-4fdd2a2b] {
//   font-size: 15px;
// }
.navTitle {
  font-size: v-bind(fontSize);
  display: inline-block;
  word-wrap: break-word;
  white-space: normal;
  line-height: initial;
}

.transition-box {
  margin-bottom: 10px;
  width: 200px;
  height: 100px;
  border-radius: 4px;
  background-color: #409EFF;
  text-align: center;
  color: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
  margin-right: 20px;
}
</style>
